import React from 'react';
import {createFragmentContainer, graphql, readInlineData} from 'react-relay';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {REPORT_TYPE} from '../../constants';
import ReportedTimePage, {reportedTimePageQuery} from '../../components/insights/reported-time-portfolio-report/reported_time_page';
import TaskReportPage, {taskReportPageQuery} from '../../components/insights/task-report/TaskReportPage';
import {GenericReportContextProvider} from '../../components/insights/GenericReportContext';
import UtilizationReport, {UtilizationReportQuery} from '../../components/insights/utilization-report/UtilizationReport';
import ProjectPortfolioReport, {ProjectPortfolioReportQuery} from '../../components/insights/project-portfolio-report/ProjectPortfolioReport';
import ForecastQueryRenderer from '../../ForecastQueryRenderer';

const genericSavedReportConductor = ({viewer, intl}) => {
	const savedReport = viewer.company.savedReport;
	const actualPersonId = viewer.actualPersonId;

	switch (savedReport.type) {
		case REPORT_TYPE.TIME_REG: {
			return (
				<ForecastQueryRenderer
					key="query-render-reportedTimePage"
					componentName="reported_time_page"
					query={reportedTimePageQuery}
					variables={{savedReportId: savedReport.id}}
					showLoader={true}
					render={relayProps => {
						return (
							<GenericReportContextProvider actualPersonId={actualPersonId} savedReportRef={savedReport} reportType={REPORT_TYPE.TIME_REG}>
								<ReportedTimePage {...relayProps} />
							</GenericReportContextProvider>
						);
					}}
				/>
			);
		}
		case REPORT_TYPE.PROJECT_PORTFOLIO_REPORT: {
			return (
				<ForecastQueryRenderer
					key="query-render-projectPortfolioReportQuery"
					componentName="project_portfolio_report"
					query={ProjectPortfolioReportQuery}
					variables={{savedReportId: savedReport.id}}
					showLoader={true}
					authorizeAccessRoute={'project-portfolio-report'}
					render={relayProps => {
						return (
							<GenericReportContextProvider actualPersonId={actualPersonId} savedReportRef={savedReport} reportType={REPORT_TYPE.PROJECT_PORTFOLIO_REPORT}>
								<ProjectPortfolioReport {...relayProps} />
							</GenericReportContextProvider>
						);
					}}
				/>
			);
		}
		case REPORT_TYPE.UTILIZATION_REPORT: {
			return (
				<ForecastQueryRenderer
					key="query-render-reportedTimePage"
					componentName="utilization_report"
					query={UtilizationReportQuery}
					variables={{savedReportId: savedReport.id}}
					showLoader={true}
					authorizeAccessRoute={'utilization-report'}
					render={relayProps => {
						return (
							<GenericReportContextProvider actualPersonId={actualPersonId} savedReportRef={savedReport} useSavedReport reportType={REPORT_TYPE.UTILIZATION_REPORT}>
								<UtilizationReport {...relayProps} useSavedReport />
							</GenericReportContextProvider>
						);
					}}
				/>
			);
		}
		case REPORT_TYPE.TASK_REPORT: {
			return (
				<ForecastQueryRenderer
					key="query-render-task-report"
					componentName="task_report_page"
					query={taskReportPageQuery}
					variables={{savedReportId: savedReport.id}}
					showLaoder={true}
					authorizeAccessRoute={'task-report'}
					render={relayProps => (
						<GenericReportContextProvider actualPersonId={actualPersonId} savedReportRef={savedReport} useSavedReport reportType={REPORT_TYPE.TASK_REPORT}>
							<TaskReportPage {...relayProps} useSavedReport />
						</GenericReportContextProvider>
					)}
				/>
			);
		}

		default: {
		}
	}
};

export function processSavedReport(savedReportRef) {
	const savedReport = readInlineData(
		graphql`
			fragment genericSavedReportConductor_savedReport on SavedReportType @inline {
				id
				updatedAt
				updatedBy {
					id
					fullName
				}
				type
				name
				person {
					id
					active
				}
				groupingOne
				groupingTwo
				eyeApplied
				filterApplied
				startDate
				endDate
				periodType
				periodDate
			}
		`,
		savedReportRef
	);
	return savedReport;
}

const genericSavedReportConductorQuery = graphql`
	query genericSavedReportConductorQuery_Query($savedReportId: String) {
		viewer {
			actualPersonId
			component(name: "generic_saved_report_conductor")
			...genericSavedReportConductor_viewer @arguments(savedReportId: $savedReportId)
		}
	}
`;

export {genericSavedReportConductorQuery};

export default injectIntl(
	withRouter(
		createFragmentContainer(genericSavedReportConductor, {
			viewer: graphql`
				fragment genericSavedReportConductor_viewer on Viewer @argumentDefinitions(savedReportId: {type: "String"}) {
					actualPersonId
					company {
						savedReport(id: $savedReportId) {
							...genericSavedReportConductor_savedReport
							id
							type
							name
						}
					}
				}
			`,
		})
	)
);
